import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { channelDashboardApi } from '../services/channelDashboardApi';

export const useSyncChannel = (channelId: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (resources?: string[]) => channelDashboardApi.sync(channelId!, resources),
    onSuccess: () => {
      toast.success('Sincronização iniciada');
      // otimista: o socket channel:sync-* atualiza o estado ao concluir; invalida overview
      void queryClient.invalidateQueries({ queryKey: ['channel-dashboard', channelId, 'overview'] });
    },
    onError: () => {
      toast.error('Não foi possível iniciar a sincronização');
    },
  });
};
